import { ENV_HOMEPAGE } from 'modules/common/constants/env';

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${ENV_HOMEPAGE}/service-worker.js`)
        .catch(error => {
          // eslint-disable-next-line
          console.error('Error during service worker registration:', error);
        });
    });
  }
}
